import type { BlockquoteBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface BlockquoteBlockEditorProps {
  content: BlockquoteBlockContent | null
  onChange: (content: BlockquoteBlockContent) => void
}

export function BlockquoteBlockEditor({
  content,
  onChange,
}: BlockquoteBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<BlockquoteBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Blockquote</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Quote</Label>
          <Textarea
            value={c.quote ?? ""}
            onChange={(e) => update({ quote: e.target.value })}
            placeholder="Quote text"
            rows={3}
            className="resize-none"
          />
        </div>
        <div>
          <Label>Attribution</Label>
          <Input
            value={c.attribution ?? ""}
            onChange={(e) => update({ attribution: e.target.value })}
            placeholder="— Author Name"
          />
        </div>
        <div>
          <Label>Source (optional)</Label>
          <Input
            value={c.source ?? ""}
            onChange={(e) => update({ source: e.target.value })}
            placeholder="Book, article, etc."
          />
        </div>
      </CardContent>
    </Card>
  )
}
